import { Component, OnInit } from '@angular/core';
import { FormControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthService } from '../_services/auth.service';
import { Router, ActivatedRoute } from '@angular/router';

import { SpinnerService } from '../_core/spinner/spinner.service';

import { LoginForm } from '../_models/login-form';
import { ValidationErrorMessageEnum } from '../constants/ValidationErrorMessageEnum';
import { OtpDataForm } from '../_models/otp-data-form';
import { OtpService } from '../_services/otp.service';
import { SnotifyService } from 'ng-snotify';
import { LoaderService } from '../_core/loader/loader.service';
import { MatSnackBar } from '@angular/material';
import { ReCaptchaV3Service } from 'ngx-captcha';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  hide = true;
  loginForm: LoginForm = new LoginForm();
  mathProblem: string;
  loginFormGroup: FormGroup;
  submitAttempt = false;
  checkUserSessionFlag = false;

  hidePassword = true;
  hideConfirmPassword = true;
  checked = false;

  title = 'Forgot Password';
  forgotPasswordForm: FormGroup;
  emailId: string;
  model: any = {};
  userName: string;
  sentOtpFlag = '';
  otpDataForm = new OtpDataForm();
  otp: any;
  otpNofifyMeg: string;
  otpErrorMeg: string;

  invalidPasswordFlag = true;
  invalidUserNameFlag = true;
  invalidOtpFlag = true;
  otpSentNotifyFlag = true;

  forgotPasswordSessionFlag = false;

  siteKey= '6LeYKL8pAAAAADeBd-_vzlsoiluWO4e4OszsoRHg';

  reCaptchaToken = '';


  constructor(
    private authService: AuthService,
    public spinnerService: SpinnerService,
    public loaderService: LoaderService,
    private formbuilder: FormBuilder,
    private router: Router,
    private reCaptchaV3Service: ReCaptchaV3Service,
    private otpService: OtpService,
    public snotifyService: SnotifyService,
    public matSnackBar: MatSnackBar) {
  }

  ngOnInit() {
    this.generateMathProblem();
    this.recaptcha();

    const checkUserSessionFlag = this.authService.checkUserSession();

    if (checkUserSessionFlag === true) {
      this.router.navigate(['/learnBasicOfPatents']);
    }
    this.loginFormValidate();
  }

  generateMathProblem() {
    const num1 = Math.floor(Math.random() * 10) + 1;
    const num2 = Math.floor(Math.random() * 10) + 1;
    this.mathProblem = `${num1} + ${num2}`;
  }

  recaptcha(): void {
    this.reCaptchaV3Service.execute(this.siteKey, 'homepage', (token) => {
      this.reCaptchaToken = token;
    },
    );
  }

  loginFormValidate() {
    console.log('Validating login form inside...'); // Log that the login form is being validated
    const emailPattern = "[[_A-Za-z0-9-\\+]+(\\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\\.[A-Za-z0-9]+)*(\\.[A-Za-z]{2,})$";
    this.loginFormGroup = this.formbuilder.group({
      'userName': new FormControl(this.loginForm.userId, [
        Validators.compose([
          Validators.minLength(5),
          Validators.maxLength(150),
          Validators.pattern(emailPattern),
          Validators.required])
      ]),

      'password': new FormControl(this.loginForm.password, [
        Validators.compose([
          Validators.minLength(5),
          Validators.maxLength(100),
          Validators.required])
      ]),
      'reCaptchaToken': [''], // Add reCaptchaToken field
      'mathAnswer': ['', [
        Validators.required,
        this.mathValidation.bind(this) // Ensure correct context
      ]],
      'honeypot': ['']
    });
    // Log the created form group
    console.log('Login form group:', this.loginFormGroup);
  }
  mathValidation(control) {
    const mathAnswer = Number(control.value);
    const answer = eval(this.mathProblem);
    if (mathAnswer !== answer) {
      return { mathAnswer: true };
    }
    return null;
}
  executeReCaptcha() {
    this.reCaptchaV3Service.execute(this.siteKey, 'login', (token) => {
      this.reCaptchaToken = token;
    });
  }

  login() {
    console.log('Logging in...'); // Log that the user is logging in
    // Log the generated math problem and user's math answer before validation
    console.log('Generated Math Problem:', this.mathProblem);
    console.log('User\'s Math Answer:', this.loginFormGroup.get('mathAnswer').value);
    this.submitAttempt = true;  
    for (let controlName in this.loginFormGroup.controls) {
      if (this.loginFormGroup.controls[controlName].invalid) {
          console.log(`Control ${controlName} is invalid.`);
          console.log(this.loginFormGroup.get('mathAnswer').errors);
      }
  }
    if (this.loginFormGroup.valid) {
      this.spinnerService.show();
      console.log('Logging in 111...'); // Log that the user is logging in
      if (this.loginFormGroup.get('honeypot').value) {
        return;
      }
        // Add the reCaptchaToken to your loginForm
    this.loginForm.reCaptchaToken = this.reCaptchaToken;
      this.authService.login(this.loginForm).subscribe(
        data => {
          console.log("Calling");
        }, error => {
          this.spinnerService.hide();
          if (error.error.error.message == 'Username Not Found.') {
            this.invalidUserNameFlag = false;
            this.invalidPasswordFlag = true;
          } else if (error.error.error.message == 'Invalid password.') {
            this.invalidUserNameFlag = true;
            this.invalidPasswordFlag = false;
          }
          this.router.navigate(['/login']);
        }
      );
    } else {
      for (let inner in this.loginFormGroup.controls) {
        this.loginFormGroup.get(inner).markAsTouched();
        this.loginFormGroup.get(inner).updateValueAndValidity();
      }
    }
  }

  getErrorMsgForUserName() {
    return this.loginFormGroup.controls.userName.errors.required ? ValidationErrorMessageEnum.EMIAL_REQUIRED :
      '';
  }

  getErrorMsgForPassword() {
    return this.loginFormGroup.controls.password.errors.required ? ValidationErrorMessageEnum.PASWORD_REQUIRED :
      '';
  }

  sentOTP() {
    if (this.loginFormGroup.controls.userName.valid) {
      this.spinnerService.show();
      let userName = this.loginFormGroup.get('userName').value;
      this.otpDataForm.userName = userName;
      this.otpService.setOtp(this.otpDataForm)
        .subscribe(
          resp => {
            let dataString = resp as OtpDataForm;
            this.otp = dataString.otp;
            this.forgotPasswordSessionFlag = true;
            this.spinnerService.hide();
            let message = "OTP sent to " + this.otpDataForm.userName + "";
            this.matSnackBar.open(message, "", {
              duration: 3000,
            });
            this.otpNofifyMeg = message;
            this.otpSentNotifyFlag = false;
          },
          error => {
            this.invalidUserNameFlag = false;
            this.spinnerService.hide();
          });
    } else {
      this.loginFormGroup.controls.userName.markAsTouched();
    }
  }

  resentOtp() {
    let userName = this.loginFormGroup.get('userName').value;
    this.otpDataForm.userName = userName;
    this.spinnerService.show();
    this.otpService.setOtp(this.otpDataForm)
      .subscribe(
        resp => {
          let dataString = resp as OtpDataForm;
          this.otp = dataString.otp;
          this.forgotPasswordSessionFlag = true;
          this.spinnerService.hide();
          let message = "OTP resent to " + this.otpDataForm.userName + "";
          this.matSnackBar.open(message, "", {
            duration: 3000,
          });
          this.otpNofifyMeg = message;
          this.otpSentNotifyFlag = false;
        },
        error => {
          this.snotifyService.error(error.error.message);
          this.spinnerService.hide();
        });
  }

  OnSubmitLoginApp() {
    this.submitAttempt = true;
    if (this.otp === this.otpDataForm.otp) {
      this.otpService.updatePassword(this.otpDataForm).subscribe(
        data => {
          this.spinnerService.show();
          let loginForm: LoginForm = new LoginForm();
          loginForm.password = this.otpDataForm.passWord;
          loginForm.userId = this.otpDataForm.userName;
          this.authService.login(loginForm).subscribe(
            data => {
              this.spinnerService.hide();
              this.router.navigate(['/dashboard']);
            }, error => {
              this.spinnerService.hide();
              console.log("error  -->" + error);
            });
        }, error => {
          this.spinnerService.hide();
          console.log("error  -->" + error);
        });
    } else {
      this.invalidOtpFlag = false;
      this.otpSentNotifyFlag = true;
      if (this.otpDataForm.otp == null) {
        this.otpErrorMeg = "Please enter otp"
      } else {
        this.otpErrorMeg = "Otp is incorrect"
      }
    }
  }

  public cancelForgotPassword() {
    window.location.replace('');
  }

}
